import React from "react";
import { PageHeader, FutureBadge } from "@/components/shared";
import { Sparkles, Construction } from "lucide-react";

export default function FuturePage({ title, desc, p3 }) {
  return (
    <div>
      <PageHeader title={title} actions={<FutureBadge />} />
      <div className="card-surface p-12 text-center max-w-2xl mx-auto mt-8">
        <span className="inline-grid place-items-center h-16 w-16 rounded-2xl mb-5" style={{ background: p3 ? "#EEF2FF" : "#FFF7ED" }}>
          {p3 ? <Sparkles size={28} className="text-indigo-500" /> : <Construction size={28} style={{ color: "var(--copper)" }} />}
        </span>
        <h2 className="text-xl font-extrabold text-slate-900">{title}</h2>
        <p className="text-sm text-slate-500 mt-2 max-w-md mx-auto">{desc}</p>
        <div className="mt-5 inline-flex items-center gap-2 text-xs font-semibold px-3 py-1.5 rounded-full" style={{ background: p3 ? "#EEF2FF" : "#FFF7ED", color: p3 ? "#4338CA" : "#B45309" }}>
          {p3 ? "Priority 3 · Future Integration" : "Priority 2 · Scaffolded — wired opportunistically"}
        </div>
        <p className="text-xs text-slate-400 mt-6">This module is present in navigation per the prototype scope. Provider abstractions and manual fallbacks are used where not fully wired.</p>
      </div>
    </div>
  );
}
